import React from 'react';
import { AppButton, Box, RoundDoneIcon, Text } from '@common-fe/common-fe';

import { Modal } from '@/components';

interface SaveSuccessModalProps {
  visible: boolean;
  payoutDefinitionName?: string;
  onClose: () => void;
}

const SaveSuccessModal: React.FC<SaveSuccessModalProps> = ({ visible, payoutDefinitionName, onClose }) => {
  return (
    <Modal visible={visible} onSetVisible={onClose} isClosingByClickOutsideBlocked>
      <Box direction="column" gap="spacing12" align="center" pad={{ vertical: 'spacing24' }}>
        <RoundDoneIcon size="48px" />
        <Text size="2xl" color="textTitle" weight="bold" textAlign="center">
          {payoutDefinitionName} has been saved
        </Text>
        <Box margin={{ top: 'spacing12' }} width="100%" align="center">
          <AppButton testId="save-success-modal_done" width="190px" onClick={onClose}>
            Got it!
          </AppButton>
        </Box>
      </Box>
    </Modal>
  );
};

export default SaveSuccessModal;
